import CronogramaTableV2 from "../CronogramaTableV2";
import { splitUtil } from "../../../util/StringUtil";

// Na visão do local a célula mostra a turma (descrição curta, se houver) e o professor.
const detalheTurmaProfessor = (c) =>
  [
    c.tdp?.turma?.descricaoAux || c.tdp?.turma?.descricao || "",
    c.tdp?.usuario ? splitUtil(c.tdp.usuario.nome, " ", 2) : "",
  ]
    .filter(Boolean)
    .join(" · ");

/** Grade semanal de ocupação do local. */
const CronogramaLocalTableV2 = ({ cronogramas }) => (
  <CronogramaTableV2 cronogramas={cronogramas} detalhe={detalheTurmaProfessor} emptyText="Nenhuma aula neste local." />
);

export default CronogramaLocalTableV2;
